import { render, staticRenderFns } from "./ActivarWhatsapp.vue?vue&type=template&id=a79ebad0&scoped=true&"
import script from "./ActivarWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ActivarWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./ActivarWhatsapp.vue?vue&type=style&index=0&id=a79ebad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79ebad0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VForm,VMain,VRow,VTextField})
